import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import MKTypography from "components/MKTypography";

import { company } from "studio-edifique/siteContent";

const currentYear = new Date().getFullYear();

export default {
  brand: {
    name: company.brandName,
    image: company.logoIcon,
    route: "/",
  },
  details: [
    {
      icon: <LocationOnIcon fontSize="small" />,
      label: company.serviceRegion,
    },
    {
      icon: <InstagramIcon fontSize="small" />,
      label: company.instagramHandle,
      href: company.instagramUrl,
    },
    {
      icon: <PhoneIcon fontSize="small" />,
      label: company.phoneDisplay,
      href: company.phoneUrl,
    },
  ],
  socials: [
    {
      icon: <WhatsAppIcon />,
      label: "WhatsApp do Studio Edifique",
      link: company.whatsappUrl,
    },
    {
      icon: <InstagramIcon />,
      label: "Instagram do Studio Edifique",
      link: company.instagramUrl,
    },
    {
      icon: <PhoneIcon />,
      label: "Ligar para o Studio Edifique",
      link: company.phoneUrl,
    },
    {
      icon: <EmailIcon />,
      label: "Enviar e-mail ao Studio Edifique",
      link: company.emailUrl,
    },
  ],
  menus: [
    {
      name: "navegação",
      items: [
        { name: "sobre nós", route: "/" },
        { name: "portfólio", route: "/portfolio" },
        { name: "time", route: "/time" },
        { name: "blog", route: "/blog" },
        { name: "contato", route: "/contato" },
      ],
    },
    {
      name: "serviços",
      items: [
        { name: "projeto arquitetônico", route: "/servicos/projeto-arquitetonico-itatiba" },
        { name: "interiores", route: "/servicos/projeto-interiores-itatiba" },
        { name: "administração de obra", route: "/servicos/administracao-obras-itatiba" },
        { name: "laudos e pareceres", route: "/servicos/laudo-tecnico-itatiba" },
      ],
    },
    {
      name: "atendimento",
      items: [
        { name: "whatsapp", href: company.whatsappUrl },
        { name: "email", href: company.emailUrl },
        { name: "instagram", href: company.instagramUrl },
        { name: company.siteDisplayUrl, href: company.siteUrl },
      ],
    },
    {
      name: "conteúdo",
      items: [
        { name: "slump test", route: "/blog/importancia-do-slump-test" },
        { name: "projeto arquitetônico", route: "/blog/importancia-do-projeto-arquitetonico" },
        {
          name: "administração de obra",
          route: "/blog/economia-com-administracao-de-obra-por-engenheiro",
        },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      {company.brandName}. Copyright &copy; {currentYear}. Arquitetura e engenharia em Itatiba.
    </MKTypography>
  ),
};
